// extracted by mini-css-extract-plugin
export default {"modaltitle":"Modal_modaltitle__qnfQY","modalcontent":"Modal_modalcontent__ROkjB","modalfooter":"Modal_modalfooter__l1xic","theme":"Modal_theme__lHJ29"};